import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface StaticPageLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  cta?: { label: string; to: string };
}

export const StaticPageLayout = ({ title, subtitle, children, cta }: StaticPageLayoutProps) => (
  <div className="container mx-auto px-4 py-10 md:py-14 max-w-4xl">
    <div className="border-b pb-6 mb-8">
      <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mb-2">{title}</h1>
      {subtitle && <p className="text-muted-foreground text-base md:text-lg">{subtitle}</p>}
    </div>
    <div className="space-y-6 text-foreground/90 leading-relaxed">
      {children}
    </div>
    {cta && (
      <div className="mt-8">
        <Button asChild className="bg-gradient-primary">
          <Link to={cta.to}>{cta.label}</Link>
        </Button>
      </div>
    )}
  </div>
);
